import React from 'react'
import { FiUpload } from "react-icons/fi"

export default function Quote() {
    return (
        <div className='bg-zinc-50 text-zinc-900'>
            <section className="bg-white px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
                <div className="mx-auto max-w-7xl text-center">
                    <p className='text-sm font-semibold uppercase tracking-[0.24em] text-red-600'>Cedonia</p>
                    <h1 className="mt-4 text-5xl font-extrabold tracking-tight text-zinc-950 sm:text-6xl">
                        Get a <span className="text-red-600">Quote</span> Now
                    </h1>
                    <p className='mx-auto mt-5 max-w-2xl text-lg leading-8 text-zinc-600'>
                        Upload a 3D model to see instant pricing, lead time, and DFM feedback.
                    </p>
                </div>
            </section>

            <section className="px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
                <div className="mx-auto max-w-4xl">
                    <form action="#" method="POST">
                        <div className="overflow-hidden rounded-lg border border-zinc-200 bg-white shadow-xl shadow-zinc-900/5">
                            <div className="p-6 sm:p-8 lg:p-10">
                                <label className="block text-sm font-semibold uppercase tracking-[0.18em] text-zinc-500">3D Model</label>
                                <div className="mt-4 flex justify-center rounded-lg border-2 border-dashed border-zinc-300 bg-zinc-50 px-6 py-20 transition duration-200 hover:border-red-300 hover:bg-red-50/40">
                                    <div className="space-y-4 text-center">
                                        <div className='mx-auto flex h-16 w-16 items-center justify-center rounded-md bg-white text-red-600 shadow-sm'>
                                            <FiUpload size={"2em"} />
                                        </div>
                                        <div className="flex justify-center text-sm text-zinc-600">
                                            <label
                                                htmlFor="file-upload"
                                                className="relative cursor-pointer rounded-md font-semibold text-red-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-red-500 focus-within:ring-offset-2 hover:text-red-700"
                                            >
                                                <span>Upload a 3D model to see instant pricing, lead time, and DFM feedback.</span>
                                                <input id="file-upload" accept='.step, .stp, .sldprt, .stl, .3dxml, .prt, .sat' name="file-upload" type="file" className="sr-only" />
                                            </label>
                                        </div>
                                        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-zinc-500">STEP | STP | SLDPRT | STL | IPT | 3DXML | PRT | SAT files</p>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-end border-t border-zinc-200 bg-zinc-50 px-6 py-4 sm:px-8">
                                <button
                                    type="submit"
                                    className="inline-flex justify-center rounded-md bg-red-600 px-6 py-3 text-sm font-semibold text-white shadow-sm shadow-red-900/10 transition duration-200 hover:-translate-y-0.5 hover:bg-red-700 hover:shadow-lg hover:shadow-red-900/15 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                                >
                                    Send
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    )
}
